import { AutogenLayoutBrokeragePlanningProfileFilter } from "./autogen/AutogenLayoutBrokeragePlanningProfileFilter";
import { BrokeragePlanningProfile } from "./BrokeragePlanningProfile";

export class BrokeragePlanningProfileFilter extends AutogenLayoutBrokeragePlanningProfileFilter {

    override onLoad() {
        (this.layoutProfile as BrokeragePlanningProfile).textboxTitle.required = false;
    }
}
